<template>
  <div class="query-page">
    <main class="query-stage">
      <div class="query-title">
        <h1>证书查询系统</h1>
        <p>CERTIFICATE QUERY SYSTEM</p>
      </div>

      <section class="query-card" aria-label="证书信息查询">
        <label class="field">
          <span class="field-title">
            <span class="field-icon field-icon-name" aria-hidden="true"></span>姓名
          </span>
          <input
            v-model="form.name"
            type="text"
            autocomplete="off"
            placeholder="请输入姓名"
            @keyup.enter="submitQuery"
          />
        </label>

        <label class="field">
          <span class="field-title">
            <span class="field-icon field-icon-sex" aria-hidden="true"></span>性别
          </span>
          <select v-model="form.sex">
            <option value=""></option>
            <option value="男">男</option>
            <option value="女">女</option>
          </select>
        </label>

        <label class="field">
          <span class="field-title">
            <span class="field-icon field-icon-card" aria-hidden="true"></span>身份证号
          </span>
          <input
            v-model="form.cardid"
            type="text"
            autocomplete="off"
            placeholder="请输入18位身份证号"
            @keyup.enter="submitQuery"
          />
        </label>

        <button class="submit" type="button" :disabled="loading" @click="submitQuery">
          {{ loading ? "查询中..." : "查询证书" }}
        </button>
      </section>

      <section v-if="results.length > 1" class="pick-card">
        <div class="pick-title">请选择查询结果</div>
        <button
          v-for="item in results"
          :key="item._id"
          class="pick-item"
          type="button"
          @click="goResult(item._id)"
        >
          <strong>{{ item.name }}</strong>
          <span>{{ item.cardid }} / {{ item.certifyname || "证书信息" }}</span>
        </button>
      </section>
    </main>
    <footer class="query-footer">
      Copyright ©2022：bjrs.org.cn 北京软数信息技术研究院　京ICP备16059467号-5
    </footer>
  </div>
</template>

<script>
import { Message } from "element-ui";

export default {
  name: "InfoQuery",
  data() {
    return {
      form: {
        name: "",
        cardid: "",
        sex: "",
      },
      loading: false,
      results: [],
    };
  },
  methods: {
    submitQuery() {
      const name = this.form.name.trim();
      const cardid = this.form.cardid.trim();
      const sex = this.form.sex.trim();
      if (!name && !cardid && !sex) {
        Message.error("请输入姓名、性别或身份证号");
        return;
      }

      this.loading = true;
      this.results = [];
      const params = [];
      if (name) params.push(`name=${encodeURIComponent(name)}`);
      if (cardid) params.push(`cardid=${encodeURIComponent(cardid)}`);
      if (sex) params.push(`sex=${encodeURIComponent(sex)}`);

      this.$axios
        .get(`/api/infoQuery/query?${params.join("&")}`)
        .then((res) => {
          const data = res.data && res.data.data ? res.data.data : [];
          if (!data.length) {
            Message.error("未查询到相关证书信息，请确认输入内容是否正确");
            return;
          }
          if (data.length === 1) {
            this.goResult(data[0]._id);
            return;
          }
          this.results = data;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    goResult(id) {
      this.$router.push(`/infoQuery/result/${id}`);
    },
  },
};
</script>

<style scoped>
.query-page {
  position: relative;
  min-height: 100vh;
  background: #def6ff;
  overflow: hidden;
}

.query-page:before {
  content: "";
  position: absolute;
  inset: 0;
  background: url("/static/img/info-query/figma/query-pc-bg-c327d37.png") right center/cover
    no-repeat;
  pointer-events: none;
}

.query-stage {
  position: relative;
  z-index: 1;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 42px 20px 68px;
  box-sizing: border-box;
}

.query-title {
  margin-bottom: 52px;
  text-align: center;
}

.query-title h1 {
  margin: 0;
  font-size: 48px;
  line-height: 58px;
  font-weight: 700;
  letter-spacing: 0.35px;
  color: #168ff0;
  background: linear-gradient(90deg, #08bdf5 0%, #8e68f4 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}

.query-title p {
  margin: 12px 0 0;
  font-size: 18px;
  line-height: 24px;
  color: rgba(79, 100, 116, 0.34);
  letter-spacing: 0.35px;
}

.query-card {
  width: 590px;
  min-height: 548px;
  padding: 47px 47px 42px;
  background: rgba(255, 255, 255, 0.98);
  border: 1px solid rgba(88, 169, 255, 0.45);
  border-radius: 18px;
  box-shadow: 0 18px 38px rgba(37, 139, 205, 0.14);
  box-sizing: border-box;
}

.field {
  display: block;
  margin-bottom: 27px;
}

.field-title {
  display: flex;
  align-items: center;
  margin-bottom: 14px;
  font-size: 18px;
  line-height: 24px;
  font-weight: 700;
  color: #2f3b4c;
}

.field-icon {
  position: relative;
  width: 24px;
  height: 24px;
  margin-right: 9px;
  flex: 0 0 24px;
}

.field-icon-name:before,
.field-icon-name:after,
.field-icon-sex:before,
.field-icon-sex:after,
.field-icon-card:before,
.field-icon-card:after {
  content: "";
  position: absolute;
  box-sizing: border-box;
}

.field-icon-name:before {
  left: 8px;
  top: 3px;
  width: 8px;
  height: 8px;
  border: 2px solid #168ff0;
  border-radius: 50%;
}

.field-icon-name:after {
  left: 4px;
  bottom: 3px;
  width: 16px;
  height: 10px;
  border: 2px solid #168ff0;
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
  border-bottom: 0;
}

.field-icon-sex:before {
  left: 4px;
  top: 4px;
  width: 11px;
  height: 11px;
  border: 2px solid #168ff0;
  border-radius: 50%;
}

.field-icon-sex:after {
  right: 3px;
  bottom: 3px;
  width: 11px;
  height: 11px;
  border-right: 2px solid #168ff0;
  border-bottom: 2px solid #168ff0;
  transform: rotate(45deg);
}

.field-icon-card {
  border: 2px solid #168ff0;
  border-radius: 3px;
  box-sizing: border-box;
}

.field-icon-card:before {
  left: 4px;
  top: 6px;
  width: 5px;
  height: 5px;
  border: 1px solid #168ff0;
  border-radius: 50%;
}

.field-icon-card:after {
  right: 4px;
  top: 7px;
  width: 8px;
  height: 2px;
  background: #168ff0;
  box-shadow: 0 5px 0 #168ff0;
}

.field input,
.field select {
  display: block;
  width: 100%;
  height: 58px;
  border: 1px solid #bddcff;
  border-radius: 13px;
  background: #f7fbff;
  padding: 0 22px;
  box-sizing: border-box;
  color: #27384a;
  font-size: 16px;
  outline: none;
}

.field input:focus,
.field select:focus {
  border-color: #21a7ed;
  background: #fff;
}

.submit {
  width: 100%;
  height: 62px;
  margin-top: 42px;
  border: 0;
  border-radius: 11px;
  background: linear-gradient(90deg, #2488ff 0%, #00b7d8 100%);
  box-shadow: 0 8px 14px rgba(17, 139, 225, 0.25);
  color: #fff;
  font-size: 16px;
  cursor: pointer;
}

.query-footer {
  position: absolute;
  z-index: 1;
  left: 0;
  right: 0;
  bottom: 22px;
  text-align: center;
  color: rgba(79, 100, 116, 0.55);
  font-size: 12px;
  line-height: 18px;
  letter-spacing: 0.5px;
}

.submit:disabled {
  opacity: 0.72;
  cursor: default;
}

.pick-card {
  width: 360px;
  max-height: 260px;
  margin-top: 16px;
  padding: 14px 18px;
  background: rgba(255, 255, 255, 0.98);
  box-shadow: 0 12px 30px rgba(37, 139, 205, 0.14);
  box-sizing: border-box;
  overflow: auto;
}

.pick-title {
  margin-bottom: 8px;
  font-size: 13px;
  color: #22a8ee;
  font-weight: 700;
}

.pick-item {
  display: block;
  width: 100%;
  min-height: 46px;
  padding: 8px 0;
  border: 0;
  border-top: 1px solid #edf5fa;
  background: transparent;
  text-align: left;
  cursor: pointer;
}

.pick-item strong,
.pick-item span {
  display: block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.pick-item strong {
  font-size: 13px;
  line-height: 18px;
  color: #263b50;
}

.pick-item span {
  margin-top: 2px;
  font-size: 12px;
  line-height: 16px;
  color: #77899a;
}

@media (max-width: 640px) {
  .query-page {
    background: #def6ff url("/static/img/info-query/figma/query-mobile-bg-e9771f0.png") center top /
      cover no-repeat;
  }

  .query-page:before {
    background-image: url("/static/img/info-query/figma/query-mobile-gradient-883e1d6.png");
    background-position: left top;
    background-size: cover;
    opacity: 0.9;
  }

  .query-stage {
    justify-content: flex-start;
    padding: 70px 28px 68px;
  }

  .query-title {
    margin-bottom: 31px;
  }

  .query-title h1 {
    font-size: 28px;
    line-height: 36px;
  }

  .query-title p {
    margin-top: 6px;
    font-size: 12px;
    line-height: 18px;
  }

  .query-card {
    width: 100%;
    max-width: 286px;
    min-height: 438px;
    padding: 30px 25px 31px;
    border-radius: 12px;
  }

  .field {
    margin-bottom: 15px;
  }

  .field-title {
    margin-bottom: 8px;
    font-size: 14px;
    line-height: 20px;
  }

  .field-icon {
    width: 18px;
    height: 18px;
    flex-basis: 18px;
    margin-right: 7px;
  }

  .field-icon-name:before {
    left: 6px;
    top: 2px;
    width: 6px;
    height: 6px;
    border-width: 1.5px;
  }

  .field-icon-name:after {
    left: 3px;
    bottom: 2px;
    width: 12px;
    height: 8px;
    border-width: 1.5px;
  }

  .field-icon-sex:before {
    left: 3px;
    top: 3px;
    width: 9px;
    height: 9px;
    border-width: 1.5px;
  }

  .field-icon-sex:after {
    right: 2px;
    bottom: 2px;
    width: 9px;
    height: 9px;
    border-right-width: 1.5px;
    border-bottom-width: 1.5px;
  }

  .field-icon-card {
    border-width: 1.5px;
  }

  .field-icon-card:before {
    left: 3px;
    top: 5px;
    width: 4px;
    height: 4px;
  }

  .field-icon-card:after {
    right: 3px;
    top: 5px;
    width: 6px;
    height: 1.5px;
    box-shadow: 0 4px 0 #168ff0;
  }

  .field input,
  .field select {
    height: 39px;
    border-radius: 8px;
    padding: 0 12px;
    font-size: 13px;
  }

  .submit {
    height: 38px;
    margin-top: 24px;
  }

  .pick-card {
    width: 100%;
    max-width: 276px;
  }

  .query-footer {
    bottom: 15px;
    padding: 0 24px;
    box-sizing: border-box;
    font-size: 10px;
    line-height: 16px;
  }
}
</style>
